module.exports = "<p>base works!</p>\n"